<template>
    <b-card id="preparacionRelacionadoDisplayer" header="Preparación relacionada" variant="info" v-if="preparacionData">
        <b-row>
            <b-col cols="2">
                <img-portal class="img" :src="preparacionData.imagen" />
            </b-col>
            <b-col>
                <h2>{{preparacionData.titulo_preparacion}}</h2>
                <h3 class="date" v-if="preparacionData.estatus == 'Finalizada'">{{preparacionData.fecha_finalizacion | humanizar_fecha}}</h3>
                <p v-if="preparacionData.comentarios">"{{preparacionData.comentarios}}"</p>
                <b-row>
                    <b-col>
                        Duración
                        <br>
                        <strong>{{
                            (parseInt(preparacionData.duracion_preparacion_min) + 
                            parseInt(preparacionData.duracion_coccion_min) + 
                            parseInt(preparacionData.duracion_abatimiento_min)) | minutes_to_time
                        }}</strong>
                    </b-col>
                    <b-col v-if="authGetUser.tipoUsuario == 'Admin'">
                        Costo unitario 
                        <br>
                        <strong>{{ preparacionData.costo_unitario | currency }}</strong>
                    </b-col>
                    <b-col>
                        Precio unitario <br> 
                        <strong>{{ preparacionData.precio_unitario | currency }}</strong>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import { mapGetters } from 'vuex'
import imgPortal from '../../elements/img-portal.vue'
export default {
	components: { imgPortal },
    computed: {
        ...mapGetters(['authGetUser'])
    },
    name: 'preparacionRelacionadoDisplayer',
    props: {
        preparacionData: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="less">
    #preparacionRelacionadoDisplayer {
        .date {
            font-size: 0.9em;
            color: var(--info);
        }
        .img {
            width: 6em;
            height: 6em;
        }
    }
</style>